import './bootstrap';
import './bootstrap';

window.Vue = import('vue').withDefaults;

import { createApp, markRaw } from 'vue/dist/vue.esm-bundler'
import { TailwindPagination } from 'laravel-vue-pagination'
import { registerValidationRules } from './validation/rules.js';
import router from './router/index'
import Editor from '@tinymce/tinymce-vue'
import SubmitButton from './components/micro/SubmitButton.vue'
import SideBarSubmitButton from './components/micro/SideBarSubmitButton.vue'
import BaseFormInput from './components/micro/BaseFormInput.vue'
import BaseFormSelect from './components/micro/BaseFormSelect.vue'
import RichTextRenderer from 'contentful-rich-text-vue-renderer'
import LaravelPermissionToVueJS from 'laravel-permission-to-vuejs'
import { createPinia } from 'pinia'
import i18n from './i18n/index'
import helper from './helpers'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { loadAgentBranding } from "./composables/agentBranding.js";
// import { loadFamilAgentColors } from "./composables/familAgentColors";
// import { loadAgentFonts } from "./composables/agentFonts";
import {useAdminStore} from "@/components/stores/admin.js";
import {useUserStore} from "@/components/stores/user.js";
import { cleanSupplierConfirmation } from "@/helpers/supplier.js";
import { faPaperPlaneTop as fasPaperPlaneTop, faArrowUpRightFromSquare, faWashingMachine, faNotebook, faFilter, faUpLong, faDownLong, faGlobe, faDownload, faTicketAirline,
    faSquareUser, faDiamonds4, faFolderMagnifyingGlass, faFlaskRoundPotion, faFolderGrid, faPuzzle, faSpinner, faDownFromLine, faComment, faFolderGear, faKey, faBallotCheck,
    faBadgePercent, faSquareDollar, faFileXml } from '@fortawesome/pro-solid-svg-icons'


import { faPaperPlaneTop as farPaperPlaneTop, faTrash, faBan, faGears, faGear, faLink, faCircleXmark,
    faUpload, faRotate, faRotateRight, faRotateLeft, faPaperclip, faCircleExclamation, faLocationDot, faTag, faList, faCreditCard,
    faUnlock, faRocket, faSquareQuestion, faSunBright, faMagnifyingGlass, faFileCirclePlus, faBrainCircuit, faCheck, faXmark,
    faPlaneSlash, faPlane, faFaceUnamused, faBuildingCircleXmark, faEnvelope, faArrowUp, faArrowLeft, faPlus, faChartBullet, faSliders, faBook,
    faBuildingCircleCheck, faBuildingCircleExclamation, faUserCheck, faUserPlus, faPaperPlane, faLock, faBrowser, faFolder, faGripVertical } from '@fortawesome/pro-regular-svg-icons'

import { faPenToSquare, faCopy, faFloppyDisk, faFile, faAddressBook, faUser as farUser, faLightbulb, faMessage, faFaceMeh,
    faFaceSmile, faFaceFrown, faStar, faBuilding, faCircleUser, faCircleCheck, faCircle, } from '@fortawesome/free-regular-svg-icons'

import { faUser as fasUser, faCalendarDays, faMoon, faArrowRightFromBracket, faArrowRightToBracket, faFileExcel, faBuilding as fasBuilding, faBuildingCircleXmark as fasBuildingCircleXmark,
    faGift as fasGift, faPerson as fasPerson, faPersonCircleXmark as fasPersonCircleXmark, faChevronUp, faChevronDown, faChevronLeft, faChevronRight, faBed, faBinoculars,
    faShip, faCar, faTrain, faRightLeft, faBasketShopping, faUserTie, faIndustry, faBars, faThumbtack, faThumbtackSlash, faScrewdriverWrench, faToolbox, faUsers, faArrowsRotate,
    faCodeBranch, faBriefcase, faImages, faSuitcase, faBarsProgress, faMartiniGlass, faPersonChalkboard, faUtensils, faDumbbell, faSquareParking, faPersonSwimming, faMapLocationDot,
    faPlay, faBell, faPhone, faFile as fasFile, faExclamationTriangle, faEllipsis, faShare, faX, faCoins, faHeading, faCircleDown, faMap, faStar as faStarSolid, faPlane as fasPlane,
    faFontAwesome, faBox, faClipboard } from '@fortawesome/free-solid-svg-icons'

import { faGoogle, faWhatsapp, faFacebook, faInstagram, faYoutube, faInstagramSquare, faFacebookSquare, faYoutubeSquare } from '@fortawesome/free-brands-svg-icons';

import { faMobile, faUserHeadset, faFilePdf } from '@fortawesome/pro-light-svg-icons';

import * as Sentry from "@sentry/vue";

import { versionWatcher } from './composables/versionWatcher';


library.add(fasPaperPlaneTop, farPaperPlaneTop, faTrash, faPenToSquare, faBan, faGear, faLink, faCircleXmark,
    faArrowUpRightFromSquare, faCopy, faFloppyDisk, faUpload, faRotate, faRotateRight, faRotateLeft, faFile, faAddressBook, farUser,
    fasUser, faPaperclip, faCircleExclamation, faLocationDot, faTag, faList, faCreditCard, faCalendarDays,
    faUnlock, faRocket, faSquareQuestion, faMoon, faLightbulb, faSunBright, faMessage, faArrowRightFromBracket, faArrowRightToBracket,
    faMagnifyingGlass, faFileCirclePlus, faBrainCircuit, faCheck, faXmark, faFileExcel, faPlaneSlash, faPlane, faFaceMeh,
    faFaceSmile, faFaceFrown, faFaceUnamused, faStar, faBuilding, fasBuilding, faBuildingCircleXmark, fasBuildingCircleXmark,
    fasGift, fasPerson, fasPersonCircleXmark, faCircleUser, faChevronUp, faChevronDown, faChevronLeft, faChevronRight,
    faNotebook, faCircleCheck, faCircle, faEnvelope, faArrowUp, faArrowLeft, faFilter, faUpLong, faDownLong, faPlus, faGlobe, faGoogle, faBed,
    faBinoculars, faShip, faCar, faTrain, faDownload, faRightLeft, faBasketShopping, faTicketAirline, faSquareUser, faDiamonds4,
    faFolderMagnifyingGlass, faCodeBranch, faBriefcase, faUserTie, faIndustry, faBars, faThumbtack, faThumbtackSlash, faScrewdriverWrench,
    faToolbox, faUsers, faArrowsRotate,faWhatsapp, faGears, faChartBullet, faImages, faSuitcase, faSliders, faFlaskRoundPotion, faFolderGrid,
    faPuzzle, faSpinner, faBarsProgress, faDownFromLine, faMartiniGlass, faPersonChalkboard, faFolderGear,
    faUtensils, faDumbbell, faWashingMachine, faSquareParking, faPersonSwimming, faMap, faMapLocationDot, faPlay, faBell, faPhone, faBook,
    faBuildingCircleCheck, faBuildingCircleExclamation, faUserCheck, faUserPlus, faExclamationTriangle, fasFile, faEllipsis, faPaperPlane, faComment,
    faShare, faX, faMobile, faUserHeadset, faFacebook, faInstagram, faYoutube, faInstagramSquare, faFacebookSquare, faYoutubeSquare, faFilePdf, faLock, 
    faBrowser, fasPlane, faCoins, faFontAwesome, faBallotCheck, faBox, faClipboard, faBadgePercent, faSquareDollar, faKey,
    faHeading, faCircleDown, faStarSolid, faGripVertical, faBallotCheck, faFolder, faFileXml )


versionWatcher()

//  Form validation rules
registerValidationRules()


const app = createApp({})

if (import.meta.env.VITE_APP_ENV !== 'local') {
    Sentry.init({
        app,
        dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
        environment: import.meta.env.VITE_APP_ENV,
        tracesSampleRate: 0.25,
        integrations: [Sentry.browserTracingIntegration({router})],
        trackComponents: true
    });
}

const pinia = createPinia()
pinia.use(({store}) => {
    store.router = markRaw(router)
})


app.use(router)
app.use(i18n)
app.use(helper)
app.use(LaravelPermissionToVueJS)
app.use(pinia)

app.component('Pagination', TailwindPagination);
app.component('editor', Editor);
app.component('submit-button', SubmitButton);
app.component('sidebar-submit-button', SideBarSubmitButton);
app.component('base-form-input', BaseFormInput);
app.component('base-form-select', BaseFormSelect);
app.component('rich-text', RichTextRenderer);
app.component('font-awesome-icon', FontAwesomeIcon)

// Global Helpers
app.config.globalProperties.$cleanSupplierConfirmation = cleanSupplierConfirmation;

// await loadFamilAgentColors();
//
// app.mount('#app');

const admin = useAdminStore()
const user = useUserStore()

// Interceptor to redirect front-end when user session times out
axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    console.log(error);
    // Admin redirect when session expires
    if (error.response.data.message.includes('admin')) {
        admin.admin.data.name = null
        window.location.href = '/admin/login'
    }

    // User redirect when session expires
    else if (error.response.data.message.includes('Unauthenticated')) {
        user.user = {
            data: {
                preferences: null,
                agent_display_name: null,
                user_name: null,
                main_user: false
            }
        }
        window.location.href = '/'
    }


    // Return all other errors
    return Promise.reject(error);

});

async function bootstrap() {
    try {
        // await loadFamilAgentColors();
        // await loadAgentFonts();
        await loadAgentBranding();
    } catch (error) {
        console.error('Failed to load agent branding:', error);
    }

    app.mount('#app');
}

bootstrap();

